import { createRouter, createWebHistory } from "vue-router";
import Login from "./components/Login.vue";
import Admin from "./components/Admin.vue";
import ProjectPrintPage from "@/components/ProjectPrintPage.vue";

// 🔐 Define the passwords mapped to your environmental configs
const PASSWORDS = {
  admin: process.env.VUE_APP_ADMIN_PASSWORD,
  nestleph: process.env.VUE_APP_NESTLEPH_PASSWORD,
  firjanpass: process.env.VUE_APP_FIRJANPASS_PASSWORD,
  gefigurinha: process.env.VUE_APP_GEFIGURINHA_PASSWORD, // FIXED: Added missing 'V' to process.env config string
};

const STORAGE_KEY = "authRoles"; // we'll store roles here

function getRoles() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

function saveRoles(roles) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(roles));
}

// Does the user have access to this role? (admin overrides everything)
function hasAccess(requiredRole) {
  const roles = getRoles();
  if (roles.includes("admin")) return true;
  if (!requiredRole) return true; // route doesn't require anything
  return roles.includes(requiredRole);
}

// Ask for password and update roles if OK
function requestAccess(requiredRole) {
  const pwd = window.prompt("Digite a senha para acessar esta página:");

  if (!pwd) return false; // cancelled

  let grantedRole = null;

  if (pwd === PASSWORDS.admin) {
    grantedRole = "admin"; // full access
  } else if (requiredRole && pwd === PASSWORDS[requiredRole]) {
    grantedRole = requiredRole;
  }

  if (!grantedRole) {
    window.alert("Senha incorreta.");
    return false;
  }

  const roles = getRoles();
  if (!roles.includes(grantedRole)) {
    roles.push(grantedRole);
    saveRoles(roles);
  }
  return true;
}

const routes = [
  { path: "/", component: Login },
  { path: "/admin", component: Admin, meta: { role: "admin" } },

  // A. The main selection menu dashboard paths point here
  {
    path: "/print",
    component: ProjectPrintPage,
    meta: { role: "admin" },
  },

  // B. Specific project custom roles use it
  {
    path: "/nestleph",
    component: ProjectPrintPage,
    meta: { role: "nestleph" },
  },
  {
    path: "/firjanpass",
    component: ProjectPrintPage,
    meta: { role: "firjanpass" },
  },
  {
    path: "/gefigurinha",
    component: ProjectPrintPage,
    meta: { role: "gefigurinha" },
  },

  // C. The general dynamic route segment at the very bottom
  {
    path: "/:projectCode",
    name: "ProjectPrint",
    component: ProjectPrintPage,
    meta: { role: "admin" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 🔐 Global guard: check role + possibly prompt for password
router.beforeEach((to, from, next) => {
  const requiredRole = to.meta.role;

  // Route doesn't need any special access
  if (!requiredRole) {
    return next();
  }

  // Already authorized for this (or admin)
  if (hasAccess(requiredRole)) {
    return next();
  }

  // Not authorized yet → ask for password
  const granted = requestAccess(requiredRole);

  if (granted) {
    return next();
  }

  // If they fail/cancel on first load (no from.name), send to "/"
  if (!from.name) {
    return next("/");
  }

  // Otherwise stay on current page
  return next(false);
});

export default router;
